import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/ThermalResistanceCalculator';

export default define`Thermal Resistance Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/ThermalResistanceCalculator`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  // eslint-disable-next-line react/jsx-props-no-spreading
  view: ({ value }) => <Renderer {...value} />,
  edit: {
    header: ui`Form`.of({
      copy: ui`Content/Basic`,
    })({ label: 'Content' }),
  },
});
